export enum PublishStatus {
  None = 1,
  Public = 2,
  Private = 3,
}
